
import { Entity } from '../base/entity';

export class DocumentItemSerial extends Entity {
  public static readonly TABLENAME = "document_item_series";

  public static readonly DOCUMENT_ID = "document_id";
  public static readonly ITEM_ID = "item_id";
  public static readonly SERIAL_NO = "serial_no";
  public static readonly QUANTITY = "quantity";
  public static readonly WARRANTY_PERIOD = "warranty_period";
  public static readonly STOCK_DETAIL_ID = "stock_detail_id";

  documentId: string;
  itemId: string;
  serialNo: string;
  quantity: number;
  warrantyPeriod: string;
  stockDetailId: number;

  /* transient field */
  deleted: boolean = false;
}
